import { DropDownOption } from "../components/dropdown/DropDownComponent";

export class IconsDropdown
{
    static readonly Options: DropDownOption[] = [
        { label: 'Default', value: 'default', iconUrl: '/icons/default.svg' },
        { label: 'Question', value: 'question', iconUrl: '/icons/question.svg' },
        { label: 'Question Circle', value: 'question-circle', iconUrl: '/icons/question-circle.svg' },
        { label: 'Exclamation', value: 'exclamation', iconUrl: '/icons/exclamation.svg' },
        { label: 'Exclamation Circle', value: 'exclamation-circle', iconUrl: '/icons/exclamation-circle.svg' },
    ] as const;
}
